import * as React from 'react';
import { HelpModal } from '../HelpModal/HelpModal';
import { HelpIconButton } from '../HelpIconButton/HelpIconButton';

export const SchoolFormsHelp: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <>
      <HelpIconButton onClick={() => setIsOpen(true)} title="How school forms work" label="How school forms work" />

      <HelpModal
        isOpen={isOpen}
        title="How school forms work"
        badgeText="School forms"
        subtitle="Build the form attached to a consent request, club booking invitation or tournament confirmation request. Start from a template or build from scratch, then tailor the saved snapshot for this specific send."
        onClose={() => setIsOpen(false)}
      >
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Start with the right baseline</div>
              <div className="text-muted">
                The default template is selected automatically. You can switch to another template, reset your work back
                to its original state, or remove all existing elements and build the form from scratch.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Tailor the form</div>
              <div className="text-muted">
                Add, edit, duplicate or remove questions and content blocks. Mark questions as required or optional,
                configure choice options and validation, and drag elements into the order recipients should see.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Create workflows</div>
              <div className="text-muted">
                Use conditional visibility for answer-driven fields. Add page breaks and page-flow rules when the form
                needs branching, early submission or a different completion message for a particular answer.
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="border rounded p-3 h-100">
              <div className="font-weight-bold mb-2">Reuse what you build</div>
              <div className="text-muted">
                Changes normally apply only to this request snapshot. Apply them to the selected template when that
                template should change, or save the current form as a new reusable template without replacing the
                original.
              </div>
            </div>
          </div>
        </div>

        <div className="border rounded p-3" style={{ background: '#fffdf3' }}>
          <div className="font-weight-bold mb-2">Recommended working order</div>
          <ol className="mb-0 pl-3 text-muted">
            <li>Select the closest template or start from scratch.</li>
            <li>Adjust questions, required fields, options and ordering.</li>
            <li>Add conditional visibility or page flow only where it improves the recipient journey.</li>
            <li>Preview the complete form and test each branch.</li>
            <li>Keep the result for this send, update the selected template, or save it as a new template.</li>
          </ol>
        </div>
      </HelpModal>
    </>
  );
};

SchoolFormsHelp.displayName = 'SchoolFormsHelp';
